import { render, staticRenderFns } from "./BigThumbnailsButton.vue?vue&type=template&id=a69ec92a&"
import script from "./BigThumbnailsButton.vue?vue&type=script&lang=js&"
export * from "./BigThumbnailsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports